
import { Button, Tooltip, IconButton } from "@mui/material"

import { AddIcon, SaveIcon, TrashIcon, CheckIcon, PencilIcon, CancelIcon } from "./icons";

export const AddButton = ({ children, ...props }) => (
  <Button
    aria-label="add"
    variant="contained"
    startIcon={<AddIcon width={20} height={20} />}
    {...props}
  >
    {children ?? "Add"}
  </Button>
);


export const CloseButton = ({ children, ...props }) => (
  <Button
    aria-label="close"
    variant="outlined"
    {...props}
  >
    {children ?? "Close"}
  </Button>
);

export const AddIconButton = ({ size = 24, ...other }) => (
  <Tooltip title="Add" placement="top" arrow>
    <span>
      <IconButton
        aria-label="add"
        size="small"
        color="inherit"
        {...other}
      >
        <AddIcon width={size} height={size} />
      </IconButton>
    </span>
  </Tooltip>
);

export const EditIconButton = ({ size = 24, tooltip, ...other }) => (
  <Tooltip title="Edit" placement="top" arrow {...tooltip}>
    <span>
      <IconButton
        aria-label="edit"
        size="small"
        color="inherit"
        {...other}
      >
        <PencilIcon width={size} height={size} />
      </IconButton>
    </span>
  </Tooltip>
);

export const DeleteIconButton = ({ size = 24, tooltip, ...other }) => (
  <Tooltip title="Delete" placement="top" arrow {...tooltip}>
    <span>
      <IconButton
        aria-label="delete"
        size="small"
        color="error"
        {...other}
      >
        <TrashIcon width={size} height={size} />
      </IconButton>
    </span>
  </Tooltip>
);

export const SaveIconButton = ({ size = 24, tooltip, ...other }) => (
  <Tooltip title="Save" placement="top" arrow {...tooltip}>
    <span>
      <IconButton
        aria-label="save"
        size="small"
        color="info"
        {...other}
      >
        <SaveIcon width={size} height={size} />
      </IconButton>
    </span>
  </Tooltip>
);

export const ConfirmIconButton = ({ size = 24, tooltip, ...other }) => (
  <Tooltip title="Confirm" placement="top" arrow {...tooltip}>
    <span>
      <IconButton
        aria-label="confirm"
        size="small"
        color="success"
        {...other}
      >
        <CheckIcon width={size} height={size} />
      </IconButton>
    </span>
  </Tooltip>
);

export const CancelIconButton = ({ size = 24, tooltip, ...other }) => (
  <Tooltip title="Cancel" placement="top" arrow {...tooltip}>
    <span>
      <IconButton
        aria-label="cancel"
        size="small"
        color="error"
        {...other}
      >
        <CancelIcon width={size} height={size} />
      </IconButton>
    </span>
  </Tooltip>
);
